<span *ngIf="!isPlural" class="inherit">micro-app</span>
<span *ngIf="isPlural" class="inherit">micro-apps</span>
<span class="registered">®</span>